module.exports = __webpack_public_path__ + "images/skewness-01-faq-desktop.png";